<script setup>
import {ref, onMounted, nextTick, computed, getCurrentInstance} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {usePageLoadingStore} from "../../../../stores/pageLoading";
import {useUserStore} from "../../stores/user";
import {useSiteMenuStore} from "../../../../stores/sitemenu";
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import KSATextButton from "@/components/ui-components/button/KSATextButton.vue";
import JobFairCorpInfoModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoModal.vue";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import SearchResidenceModal from "@/pages/user/components/modal/matching/SearchResidenceModal.vue";
import _ from "lodash";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
import JobFairJobNoticeListModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeListModal.vue";
import moment from "moment/moment";
import {useNavigationStore} from "@/stores/navigation";
import KSATextButtonStop from "../../../../components/ui-components/button/KSATextButtonStop.vue";
import { useAlertStore } from "../../../../stores/alertStore";

const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;
const { $alert, $confirm } = useAlertStore();

// 검색 - 관심카테고리
const globals = getCurrentInstance().appContext.config.globalProperties;
const searchMonths = ref(globals.$searchMonths)
const data_interests = ref(globals.$interests)
const data_schoolGb = ref(globals.$schoolGb)
const data_eduTenureGb = ref(globals.$eduTenureGb)
const data_majorGb = ref(globals.$majorGb)

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const navigationStore = useNavigationStore()
const { user, isAuthenticated } = useUserStore()

let userCorpMasterYn; // 기업마스터유무
let userCorpId; // 기업아이디

if (user.userGb === "COMPANY") {
  userCorpMasterYn = user.userInfo.corpMasterYn;
  userCorpId = user.userInfo.corporation.corpId;
}

onMounted(()=>{
  const gId = route.params.id || route.params.uuid;
  const isUuid = route.meta.apiType === 'uuid';
  if(!gId) {
    router.push({name: 'MatchingJobFairList'})
  } else {
    fetchLNBData();
    init(gId, isUuid);
  }
})

const searchOpen = ref(true) // 검색 드롭다운
const _searchInput = ref({
  searchInput: '', // 기업명
  searchMonthType: 1, // 등록(공개)일
  searchResidences: [], // 거주지역
  searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
  searchSchoolGbs: ['05','01','02','03','04'],
  searchEduTenureGbs: ['01','02','03','04','05','06'],
  searchMajorGbs: ['NONE','00','01','10','09','08','02','03','34','33','30','32','07','04','05','06','11','31','50','60','61','62','63','64','71','72','73','74','75','80','81','82','83','90'],
});

const interestGbListRef = ref(null) // 검색: 관심카테고리
const schoolGbListRef = ref(null) // 검색: 학력
const eduTenureGbListRef = ref(null) // 검색: 학력 상태
const majorGbListRef = ref(null) // 검색: 전공계열

const searchResidenceModal = ref(null) // 지역 선택 모달

// 전공계열(주전공) 펼침/닫힘
const spreadMajorGbClass = ref('min');

const jobDetail = ref({}); // 특별채용관 상세
const recruitHallList = ref([]); // 참가기업 리스트
const jobNoticeList = ref([]); // 채용공고 리스트
const resumeList = ref([]); // 인재정보 리스트
const jobFairResumeModal = ref(null); // 특별채용관 이력서
const jobNoticeListModal = ref(null); // 채용공고 선택 목록

const intvDays = ref([]);     // 면접 가능일

const tabOptions = ref([
  {label:'행사정보', value:0},
  {label:'참가기업', value:1},
  {label:'채용공고', value:2},
  {label:'인재정보', value:3}
]);
const tabIndex = ref(0)
const tabKey = ref(0); // 강제로 Tabs를 재렌더링하기 위한 키
const tabRef = ref(null)

const corpInfoModal = ref(null); // 기업정보
const jobNoticeModal =ref(null); // 채용공고

const siteMenuStore = useSiteMenuStore();

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const fetchLNBData = async () => {
  try {
    //
    await fetch('../../../../../stores/sitemenu');
    siteMenuStore.getSiteMenu();
  } catch (error) {
    console.log(error);
  }
}

// 로그인 상태에 따라 상세 정보 불러와서 joinStateGb값 추출
// joinStateGb === 11이면 참가기업, 채용공고, 인재정보 보여줌
const init = ( gId, isUuid ) => {
  const id = { value: gId };
  loadingStore.loading = true;

  if(user.userGb === 'STUDENT' || user.userGb === 'COMPANY') {
    if (user.userGb === 'STUDENT') {
      // 구직자 로그인
      if(isUuid) { // 비공개일 경우,
        jobFairGnbService.ojfGnbDetailByOjfUuidAndUserID(id.value)
            .then( async (res) => {
              loadingStore.loading = false;
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                jobDetail.value = result;
              }
            }).catch( async (err) =>  {
            loadingStore.loading = false;
            if (err.response && err.response.data && err.response.data.msg) {
              const mod = await $alert(err.response.data.msg);
              if( mod ) {
                router.go(-1);
              }
            } else {
              console.log(err);
            }
        });
      } else { // 공개일 경우,
        jobFairGnbService.ojfGnbDetailByOjfIdAndUserID(id.value)
            .then( async (res) => {
              loadingStore.loading = false;
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                jobDetail.value = result;
              }
            }).catch( async (err) =>  {
            loadingStore.loading = false;
            if (err.response && err.response.data && err.response.data.msg) {
              const mod = await $alert(err.reponse.data.msg);
              if( mod ) {
                router.go(-1);
              }
            } else {
              console.log(err);
            }
        });
      }
    } else if (user.userGb === 'COMPANY') {
      // 기업 로그인
      if(isUuid) { // 비공개일 경우,
        jobFairGnbService.ojfGnbDetailByOjfUuidAndCorpId(id.value)
            .then( async (res) => {
              loadingStore.loading = false;
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                jobDetail.value = result;
              }
            }).catch( async (err) =>  {
            loadingStore.loading = false;
            if (err.response && err.response.data && err.response.data.msg) {
              const mod = await $alert(err.response.data.msg);
              if( mod ) {
                router.go(-1);
              }
            } else {
              console.log(err);
            }
        });
      } else { // 공개일 경우,
        jobFairGnbService.ojfGnbDetailByOjfIdAndCorpId(id.value)
            .then( async (res) => {
              loadingStore.loading = false;
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                jobDetail.value = result;
              }
            }).catch( async (err) =>  {
            loadingStore.loading = false;
            if (err.response && err.response.data && err.response.data.msg) {
              const mod = await $alert(err.response.data.msg);
              if( mod ) {
                router.go(-1);
              }
            } else {
              console.log(err);
            }
        });
      }
    }
  } else {
    // 로그인 X 또는 그외 userGb
    // console.log('isUuid', isUuid);
    if(isUuid) { // 비공개일 경우,
      jobFairGnbService.ojfGnbDetailByOjfUuid(id.value)
          .then( async (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              jobDetail.value = result;
            }
          }).catch( async (err) =>  {
          loadingStore.loading = false;
          if (err.response && err.response.data && err.response.data.msg) {
            const mod = await $alert(err.response.data.msg);
            if( mod ) {
              router.go(-1);
            }
          } else {
            console.log(err);
          }
      });
    } else { // 공개일 경우,
      jobFairGnbService.ojfGnbDetailByOjfId(id.value)
          .then( async (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              jobDetail.value = result;
            }
          }).catch( async (err) =>  {
          loadingStore.loading = false;
          if (err.response && err.response.data && err.response.data.msg) {
            const mod = await $alert(err.response.data.msg);
            if( mod ) {
              router.go(-1);
            }
          } else {
            console.log(err);
          }
      });
    }
  }
}

const onClickEntryStudent = async () => {
  const ojfid = jobDetail.value.ojfId;

  if(!isAuthenticated) {
    // 로그인 X
    const mod = await $alert("로그인 후 이용해주세요.");
    navigationStore.lastAccessPage = route.fullPath;
    router.push({name: 'Signin'});
  } else {
    if (user.userGb === 'STUDENT') {
      jobFairUserService.ojfDetailEntryListByIdAndUserId2(ojfid)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              $alert(["이미 신청하신 내역이 있습니다.", "마이페이지에서 신청 현황을 확인해 주세요."]);
            } else {
              router.push({ name: 'MyPageJobFairEntry', query : { ojfId: ojfid }});
            }
          }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
      });
    } else {
      $alert(["학생/취업준비생 회원만", "참가 신청이 가능합니다."]);
    }
  }
}

const onClickEntryCompany = async () => {
  const ojfId = jobDetail.value.ojfId;

  if(!isAuthenticated) {
    // 로그인 X
    const mod = await $alert("로그인 후 이용해주세요.");

    navigationStore.lastAccessPage = route.fullPath;
    router.push({name: 'Signin'});

  } else {
    if (user.userGb === 'COMPANY' && userCorpMasterYn === 'Y') {
      const corpId = user.userInfo.corporation.corpId;

      let paramObj = {
        ojfId: ojfId,
        corpId: corpId,
      }

      jobFairCorpService.ojfCorpRecruitmentHall2(paramObj)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              $alert(["이미 신청하신 내역이 있습니다.", "마이페이지에서 신청 현황을 확인해 주세요."]);
            } else {
              router.push({ name: 'MyPageCorpRecruitmentHall', query : { ojfId: ojfId }});
            }
          }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
      });
    } else {
      $alert(["기업 마스터 회원이 아닌 경우,", "마스터 회원 신청을 먼저 진행해 주시기 바랍니다.", "* 신청방법  KSA → 공지사항 → 「마스터권한신청 안내」 참조"]);
    }
  }
}

// 특정 조건에 따라 탭 필터링
const filteredTabOptions = computed(() => {
  return tabOptions.value.filter(option => {
    return (jobDetail.value.ojfStateGb === "00" || jobDetail.value.ojfStateGb === "01" || jobDetail.value.ojfStateGb === "02")
        ? option.value !== 1 && option.value !== 2 && option.value !== 3
        : true;
  });
});

// 탭 변경
// joinStateGb === 11이면 참가기업, 채용공고, 인재정보 보여줌
// 아니라면 alert창 띄움
const onChangeTab = (option) => {
  tabIndex.value = option.value;
  currentPage.value = 1;

  if (tabIndex.value >= 1) {
    if (jobDetail.value.ojfStateGb === '04') {
      $alert("본 행사는 종료 되었습니다.");
      tabIndex.value = 0;

      // 강제로 Tabs 재렌더링을 위해 nextTick과 tabOptions 재할당
      nextTick(() => {
        // 강제 리렌더링을 위한 방법: tabKey 증가
        console
        tabKey.value++;
      });
    } else if (jobDetail.value.joinStateGb !== '11') {
      $alert("참가 신청이 승인된 회원만 확인이 가능합니다.");

      tabIndex.value = 0;

      // 강제로 Tabs 재렌더링을 위해 nextTick과 tabOptions 재할당
      nextTick(() => {
        // 강제 리렌더링을 위한 방법: tabKey 증가
        console
        tabKey.value++;
      });
    } else {
      if (tabIndex.value === 1) {
        _searchInput.value.searchInput = '';
        ojfGnbRecruitmentHallList();
      } else if (tabIndex.value === 2) {
        _searchInput.value.searchInput = '';
        ojfGnbJobNoticeList();
      } else if (tabIndex.value === 3) {
        _searchInput.value = {
          searchMonthType: 1,
          searchResidences: [],
          searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
          searchSchoolGbs: ['05','01','02','03','04'],
          searchEduTenureGbs: ['01','02','03','04','05','06'],
          searchMajorGbs: ['NONE','00','01','10','09','08','02','03','34','33','30','32','07','04','05','06','11','31','50','60','61','62','63','64','71','72','73','74','75','80','81','82','83','90'],
        };
        ojfGnbResumeList();
      }
    }
  }
}

// 버튼으로 탭 이동
// joinStateGb === 11이면 참가기업, 채용공고, 인재정보 보여줌
// 아니라면 alert창 띄움
const goToSecondTab = (value) => {
  const matchedOption = filteredTabOptions.value.find(option => option.value === value);

  if (jobDetail.value.joinStateGb !== '11') {
    $alert("참가 신청이 승인된 회원만 확인이 가능합니다.");

    tabIndex.value = 0;
  } else {
    if (matchedOption) {
      tabIndex.value = matchedOption.value;
      currentPage.value = 1;

      tabRef.value?.init(matchedOption.value);

      if (matchedOption.value === 1) {
        ojfGnbRecruitmentHallList();
      } else if (matchedOption.value === 2) {
        ojfGnbJobNoticeList();
      } else if (matchedOption.value === 3) {
        ojfGnbResumeList();
      }
    }
  }
};

// 페이징 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  ojfGnbResumeList();
}

// 페이지 클릭
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;

  if (tabIndex.value === 1) {
    ojfGnbRecruitmentHallList();
  } else if (tabIndex.value === 2) {
    ojfGnbJobNoticeList();
  } else if (tabIndex.value === 3) {
    ojfGnbResumeList();
  }
}

// s : 참가기업
// 참가기업 리스트
const ojfGnbRecruitmentHallList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    searchCorpName: _searchInput.value.searchInput,
    pageNumber: currentPage.value || 0,
    size: 12,
  }
  loadingStore.loading = true;
  jobFairGnbService.ojfGnbRecruitmentHallList(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          recruitHallList.value = result.content;
        } else {
        }
      }).catch( (error) =>  {
    // console.log(error);
    loadingStore.loading = false;
  });
}

// 기업정보 보기
const onClickJob = async (corpId) => {

  const ojfId = jobDetail.value.ojfId;
  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
  }

  if (!userCorpId) {
    // 구직자
    // 관심기업 유무
    jobFairUserService.ojfInterestHallEntryYn(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            corpInfoModal.value.init(false, true, ojfId, result);
            corpInfoModal.value.ojfCorporationDetail(corpId);
            corpInfoModal.value.ojfGnbCorpInfoJobNoticeList(corpId, ojfId);
            await corpInfoModal.value.show();

            ojfGnbRecruitmentHallList();

          } else {
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      console.log(res);
    });
  } else {
    //기업
    console.log(userCorpId, userCorpMasterYn)
    corpInfoModal.value.init(true, false, ojfId, userCorpId, userCorpMasterYn);
    corpInfoModal.value.ojfCorporationDetail(corpId);
    corpInfoModal.value.ojfGnbCorpInfoJobNoticeList(corpId, ojfId);
    await corpInfoModal.value.show();
  }
}
//관심기업
const onClickInterestCorp = (item) => {
  const inteYn = item.interestYn === 'Y' ? 'N' : 'Y';

  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    corpId: item.corpId,
    interestYn: inteYn
  }
  item.interestYn = inteYn;

  jobFairUserService.ojfInterestCorpEntryYn(paramObj)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() !== 'success') {
        $alert("실패하였습니다.");
      }
    }).catch( (res) =>  {
    loadingStore.loading = false;
    $alert("실패하였습니다.");
  });
}
// e : 참가기업

// s : 채용공고
// 채용공고 리스트
const ojfGnbJobNoticeList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    searchCorpName: _searchInput.value.searchInput,
    pageNumber: currentPage.value || 0,
    size: 12,
  }
  loadingStore.loading = true;
  jobFairGnbService.ojfGnbJobNoticeList(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobNoticeList.value = result.content;
        } else {
        }
      }).catch( (error) =>  {
    // console.log(error);
    loadingStore.loading = false;
  });
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId, applicantCnt) => {
  let ojfId = jobDetail.value.ojfId;

  if (!userCorpId) {
    let paramObj = {
      jobNoticeSeq: jobNoticeSeq,
    }
    jobFairUserService.ojfInterestJobNoticeYn(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            jobNoticeModal.value.init(false, true, false, ojfId, 0, result);
            jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
            jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
            jobNoticeModal.value.ojfCorporationDetail(corpId);
            await jobNoticeModal.value.show();

            ojfGnbJobNoticeList();
          } else {
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      console.log(res);
    });
  } else {
    // 기업
    // console.log(userCorpId, applicantCnt)

    jobNoticeModal.value.init(true, false, false, ojfId, userCorpId, 0, 0, applicantCnt);
    jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
    jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
    jobNoticeModal.value.ojfCorporationDetail(corpId);
    await jobNoticeModal.value.show();

    ojfGnbJobNoticeList();

  }
}

// 채용공고 등록
const onClickJobNoticeCreate = () => {
  const id = jobDetail.value.ojfId;
  router.push({ name: 'MyPageCorpJobNoticeCreat', query : { ojfId: id }});
}

// 관심 공고 관심여부
const onClickInterestNotice = (item) => {
  const inteYn = item.interestNoticeYn === 'Y' ? 'N' : 'Y';

    let paramObj = {
      ojfId: jobDetail.value.ojfId,
      jobNoticeSeq: item.jobNoticeSeq,
      interestNoticeYn: inteYn,
    }
    item.interestNoticeYn = inteYn;

  jobFairUserService.ojfInterestNoticeYn(paramObj)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() !== 'success') {
        $alert("실패하였습니다.");
      }
    }).catch( (res) =>  {
    loadingStore.loading = false;
    $alert("실패하였습니다.");
  });
}
// e : 채용공고

// s : 인재정보
// 인재정보 리스트
const ojfGnbResumeList = () => {

  // 학력 고졸인 경우 전공계열이 없어서 인재정보 페이지 접속 시 없음. NONE(기타)항목 추가하여 조회되게 수정.
  const reorderNoneToFront = (arr) => {
    const noneItems = arr.filter(item => item === 'NONE');
    const otherItems = arr.filter(item => item !== 'NONE');
    return [...noneItems, ...otherItems];
  };

  const processedMajorGbs = reorderNoneToFront(_searchInput.value.searchMajorGbs)
    .map(item => item === 'NONE' ? null : item);

  const residences = _.map(_searchInput.value.searchResidences).join(',');
  const interests = _.map(_searchInput.value.searchInterests).join(',');
  const schoolGbs = _.map(_searchInput.value.searchSchoolGbs).join(',');
  const eduTenureGbs = _.map(_searchInput.value.searchEduTenureGbs).join(',');
  const majorGbs = processedMajorGbs.join(',');


  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
    searchMonths: _searchInput.value.searchMonthType, // 등록(공개)일
    searchResidences: residences, // 거주지역
    searchInterests: interests, // 관심카테고리
    searchSchoolGbs: schoolGbs, // 학력
    searchEduTenureGbs: eduTenureGbs, // 학력 상태
    searchMajorGbs: majorGbs, // 전공계열
  }

  loadingStore.loading = true;
  if (user.userGb === "COMPANY") {
    jobFairGnbService.ojfGnbResumeList(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            totalPages.value = result.totalPages;
            totalCount.value = result.totalElements;
            resumeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);

            ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
          }
        }).catch( (error) =>  {
      // console.log(error);
      loadingStore.loading = false;
    });
  } else {
    jobFairGnbService.ojfGnbResumeList2(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            totalPages.value = result.totalPages;
            totalCount.value = result.totalElements;
            resumeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);

            ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
          }
        }).catch( (error) =>  {
      // console.log(error);
      loadingStore.loading = false;
    });
  }
}

// 이력서 등록
const onClickResumeCreate = (id) => {
  router.push({ name: 'MyPageJobFairResumeCreate', query : { ojfId: id }});
}

// 이력서 보기
const onClickInterestMyResume = (resumeId, ojfId, interestYn) => {
  const corpId = jobDetail.value.corpId;
  const gnbResume = 'gnbResume'; // 삭제버튼 숨기기 위한 데이터

  if (user.userGb === 'COMPANY') {
    jobFairResumeModal.value.init(false, true, interestYn);
    jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId, corpId);
    jobFairResumeModal.value.show();
  } else {
    jobFairResumeModal.value.init(true, false, 0, gnbResume);
    jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId, corpId);
    jobFairResumeModal.value.show();

  }
}

// 관심인재
const onClickInterestYn = async (resumeId, interestYn) => {
  if (interestYn === 'Y') {
    const ok = await $confirm("관심인재를 삭제하시겠습니까?", "관심인재 삭제");
    if(!ok) {
      return -1;
    } else {
      let paramObj = {
        ojfId: jobDetail.value.ojfId,
        resumeId: resumeId,
        interestYn: "N",
      }
      jobFairCorpService.ojfCropInterestEntryYn(paramObj)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              //const result = res.data.result;
              $alert("삭제하였습니다.");

              ojfGnbResumeList();
            } else {
              $alert("삭제를 실패하였습니다.");
              console.log(res);
            }
          }).catch( (res) =>  {
        loadingStore.loading = false;
        $alert("삭제를 실패하였습니다.");
        console.log(res);
      });
    }
  } else {
    const ok = await $confirm("관심인재로 등록하시겠습니까?", "관심인재 등록");
    if(!ok) {
      return -1;
    } else {
      let paramObj = {
        ojfId: jobDetail.value.ojfId,
        resumeId: resumeId,
        interestYn: "Y",
      }
      jobFairCorpService.ojfCropInterestEntryYn(paramObj)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              //const result = res.data.result;
              $alert("등록하였습니다.");

              ojfGnbResumeList();
            } else {
              $alert("등록 실패하였습니다.");
              console.log(res);
            }
          }).catch( (res) =>  {
        loadingStore.loading = false;
        $alert("등록을 실패하였습니다.");
        console.log(res);
      });
    }
  }
}

// 면접제안
// commonDatas = corpId (공통데이터는 여기서 회사Id)
const onClickResumeCorpYn = (resumeId) => {
  const ojfId = jobDetail.value.ojfId;

  jobNoticeListModal.value.interviewProposalJobNoticeList(ojfId, resumeId);
  jobNoticeListModal.value.show();
}

// 엑셀
const downloadUserResumeList = () => {
  loadingStore.loading = true;

  // 학력 고졸인 경우 전공계열이 없어서 인재정보 페이지 접속 시 없음. NONE(기타)항목 추가하여 조회되게 수정.
  const reorderNoneToFront = (arr) => {
    const noneItems = arr.filter(item => item === 'NONE');
    const otherItems = arr.filter(item => item !== 'NONE');
    return [...noneItems, ...otherItems];
  };

  const processedMajorGbs = reorderNoneToFront(_searchInput.value.searchMajorGbs)
    .map(item => item === 'NONE' ? null : item);

  const residences = _.map(_searchInput.value.searchResidences).join(',');
  const interests = _.map(_searchInput.value.searchInterests).join(',');
  const schoolGbs = _.map(_searchInput.value.searchSchoolGbs).join(',');
  const eduTenureGbs = _.map(_searchInput.value.searchEduTenureGbs).join(',');
  const majorGbs = processedMajorGbs.join(',');


  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
    searchMonths: _searchInput.value.searchMonthType, // 등록(공개)일
    searchResidences: residences, // 거주지역
    searchInterests: interests, // 관심카테고리
    searchSchoolGbs: schoolGbs, // 학력
    searchEduTenureGbs: eduTenureGbs, // 학력 상태
    searchMajorGbs: majorGbs, // 전공계열
  }


  jobFairGnbService.ojfGnbResumeExcel(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        try {
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', `${moment().format("YYYYMMDD")}_인재정보리스트.xlsx`); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } catch(e) {
          console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
        }
      }).catch( (err) =>  {
    loadingStore.loading = false;
    let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
    // Blob 응답 처리
    err.response.data.text()  // Blob을 텍스트로 변환
        .then(text => {
          try {
            // 텍스트를 JSON으로 파싱
            const responseData = JSON.parse(text);
            // 메시지 추출
            if (responseData?.result?.message) {
              errorMessage = responseData.result.message;
            }
          } catch (parseError) {
            console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
          }
          // Toast에 에러 메시지 표시
          $toast('error', errorMessage);
        });
  });
}

// e : 인재정보


// 검색 초기화
const clearSearchInput = () => {

  Object.assign(_searchInput.value, {
    searchInput: '', // 기업명 초기화
    searchMonthType: 1,
    searchResidences: [],
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchSchoolGbs: ['05','01','02','03','04'],
    searchEduTenureGbs: ['01','02','03','04','05','06'],
    searchMajorGbs: ['NONE','00','01','10','09','08','02','03','34','33','30','32','07','04','05','06','11','31','50','60','61','62','63','64','71','72','73','74','75','80','81','82','83','90'],
  });
  interestGbListRef.value.initOptions();
  schoolGbListRef.value.initOptions();
  eduTenureGbListRef.value.initOptions();
  majorGbListRef.value.initOptions();
}

const onClickSearch = () => {
  currentPage.value = 1;

  if (tabIndex.value === 1) {
    ojfGnbRecruitmentHallList();
  } else if (tabIndex.value === 2) {
    ojfGnbJobNoticeList();
  } else if (tabIndex.value === 3) {
    ojfGnbResumeList();
  }
}

// 검색 - 지역 선택 - 모달 띄우기
const showSearchResidenceModal = () => {
  searchResidenceModal.value.show(_searchInput.value.searchResidences);
}

// 검색 - 지역 선택 - 자식 컴포넌트에서 데이터 수신
const handleSelectionSubmit = (selectedResult) => {
  _searchInput.value.searchResidences = selectedResult;
};

// 검색 - 지역 선택 - 선택 지역 삭제
const deleteResidence = (residence) => {
  _searchInput.value.searchResidences = _searchInput.value.searchResidences.filter(
      (item) => item !== residence
  );
};

// 검색 - 전공계열(주전공) 펼침/닫힘
const spreadMajorGb = () => {
  spreadMajorGbClass.value = spreadMajorGbClass.value === 'min' ? '' : 'min'
}

// 모든 title이 '*'을 포함하는지 확인
const allTitlesHaveAsterisk = () => resumeList.value.every(item => item.title.includes('*'));

// title에 '*'이 포함되어 있는지 확인
const hasAsterisk = (title) => title.includes('*');

// 엑셀 다운로드
const onClickExcelDownload = async () => {
  if(totalCount.value > 0) {
    const ok = await $confirm("인재정보 목록을 내 PC로 다운로드할까요?", "다운로드");
    if(ok){
      downloadUserResumeList();
    }
  } else {
    $alert("다운로드 받을 '인재정보 목록'이 존재하지 않습니다.");
    return false;
  }
}

// 면접 가능일 조회. for 참가신청 정보 수정
const ojfIntvDay = async (ojfId) => {
  loadingStore.loading = true;
  try {
    const res = await jobFairUserService.ojfIntvDay(ojfId);
    loadingStore.loading = false;

    if (res.data.code.toLowerCase() === 'success') {
      const result = res.data.result;
      if (result) {
        const selectedDays = result.split(',').map(d => d.trim());

        intvDays.value = selectedDays.map(day => ({
          label: day,
          on: false
        }));
      }
    }
  } catch (error) {
    console.error(error);
    loadingStore.loading = false;
  }
}

// 면접 가능일 전체인지 확인 후 문구 표시
const allDays = computed(() => resumeList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected = computed(() => (intvDays.value || []).length === allDays.value.length)
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="title page-title">
        <h3>
          <span class="badge" :class="{'jobstate0': (jobDetail.ojfStateGb === '00' || jobDetail.ojfStateGb === '02'), 'jobstate2': jobDetail.ojfStateGb === '01', 'jobstate4': jobDetail.ojfStateGb === '03', 'jobstate5': jobDetail.ojfStateGb === '04'}">
            {{ jobDetail.ojfStateGb === '00' ? '신청 대기' : jobDetail.ojfStateGb === '01' ? '신청 접수중' : jobDetail.ojfStateGb === '02' ? '신청마감' : jobDetail.ojfStateGb === '03' ? '행사 진행중' : '행사 종료' }}
            <!-- 상태가 '03'일 때 -->
            <span v-if="jobDetail.ojfStateGb === '03'">
              {{ $isInRegPeriod(jobDetail.regStartYmd, jobDetail.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(jobDetail.regEndYmd) ? '(신청 마감)' : '') }}
            </span>
          </span>{{ jobDetail.ojfName }}
        </h3>
        <KSASecondaryButton text="목록" @click="router.push({name: 'MatchingJobFairList'})" />
      </div>
      <div class="lecture-wrap">
        <div class="lecture-summary">
          <div class="left-area">
            <div class="img">
              <KSAImage :src="jobDetail.ojfThombDir"/>
            </div>
          </div>
          <div class="right-area btn-area">
            <div class="btn-wrap">
              <div v-if="jobDetail.ojfStateGb === '00'">
                <!-- 신청 대기 -->
                <KSAPrimaryButton text="참가 신청 접수 대기중" disabled="disabled" />
              </div>
              <div v-if="jobDetail.ojfStateGb === '01'">
                <!-- 신청 접수중 -->
                <button class="btn" @click="onClickEntryStudent">
                  <small>[학생/취업준비생]</small>
                  참가 신청 하기
                </button>
                <button class="btn black_button" @click="onClickEntryCompany">
                  <small>[기업담당자]</small>
                  참가 신청 하기
                </button>
              </div>
              <div v-if="jobDetail.ojfStateGb === '02'">
                <!-- 신청 마감 -->
                <KSAPrimaryButton text="참가 신청 접수 마감" disabled="disabled" />
              </div>
              <div v-if="jobDetail.ojfStateGb === '03'">
                <div v-if="$isInRegPeriod(jobDetail.regStartYmd, jobDetail.regEndYmd) && jobDetail.joinStateGb !== '11'">
                  <!-- 행사 진행중 (신청 접수중) -->
                  <button class="btn" @click="onClickEntryStudent">
                    <small>[학생/취업준비생]</small>
                    참가 신청 하기
                  </button>
                  <button class="btn black_button" @click="onClickEntryCompany">
                    <small>[기업담당자]</small>
                    참가 신청 하기
                  </button>
                </div>
                <div v-else>
                  <!-- 행사 진행중 (신청 마감) -->
                  <KSAPrimaryButton text="참가기업 보기" @click="goToSecondTab(1)" />
                  <KSAPrimaryButton text="채용공고 보기" @click="goToSecondTab(2)" />
                  <KSAPrimaryButton text="인재정보 보기" @click="goToSecondTab(3)" />
                </div>
              </div>
              <div v-if="jobDetail.ojfStateGb === '04'">
                <!-- 행사 종료 -->
                <KSAPrimaryButton text="행사 종료" disabled="disabled" />
              </div>
            </div>
            <div class="info">
              <p>
                <span>접수기간</span>
                <span v-if="jobDetail.regStartYmd && jobDetail.regEndYmd">{{ $yyyymmdd(jobDetail.regStartYmd) }} ~ {{ $yyyymmdd(jobDetail.regEndYmd) }}</span>
                <span v-else>-</span>
              </p>
              <p>
                <span>행사기간</span>
                <span v-if="jobDetail.ojfStartYmd && jobDetail.ojfEndYmd">{{ $yyyymmdd(jobDetail.ojfStartYmd) }} ~ {{ $yyyymmdd(jobDetail.ojfEndYmd) }}</span>
                <span v-else>-</span>
              </p>
              <p>
                <span>면접기간</span>
                <span>{{ jobDetail.ojfIntvDay || '-' }}</span>
              </p>
              <p>
                <span>장소</span>
                <span>{{ jobDetail.ojfPlace || '-' }}</span>
              </p>
              <p>
                <span>주최</span>
                <span>{{ jobDetail.ojfHost || '-' }}</span>
              </p>
              <p v-if="jobDetail.summary">
                <small class="mt-sm">*{{ jobDetail.summary }}</small>
              </p>
            </div>
          </div>
        </div>
        <div class="lecture-detail">
          <KSATab class="tab-style_border" :options="filteredTabOptions" @change="onChangeTab" :key="tabKey" ref="tabRef"/>
          <!-- s: 행사정보 -->
          <div v-if="tabIndex === 0">
            <div class="editor-wrap" v-html="jobDetail.ojfIntro"></div>
          </div>
          <!-- e: 행사정보 -->

          <!-- s: 참가기업 -->
          <div v-if="tabIndex === 1">
            <!-- s: 검색 -->
            <div class="filter-wrap" :class="{'open': searchOpen}">
              <p @click="searchOpen = !searchOpen">검색</p>
              <div class="filter">
                <dl>
                  <dt>기업명</dt>
                  <dd>
                    <KSAInput class="text-box" v-model="_searchInput.searchInput" placeholder="기업명을 입력해주세요." />
                  </dd>
                </dl>
                <div class="btn-wrap">
                  <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                  <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
              </div>
            </div>
            <!-- e: 검색 -->
            <div v-if="recruitHallList.length > 0">
              <div class="corp-wrap">
                <dl v-for="list in recruitHallList" @click="onClickJob(list.corpId)">
                  <dt>
                    <KSAImage :src="list.ciImgDir"/>
                  </dt>
                  <dd>
                    <h1 class="text-over">{{ list.corpName }}</h1>
                    <p class="text-over"> {{ $gbNameKR('INDUSTRY_GB',list.industryGb) }}/ {{ list.bizType }}</p>
                    <p class="link text-over"><a :href="list.homeUrl">{{ list.homeUrl }}</a></p>
                    <div v-if="user.userGb === 'STUDENT'">
                      <KSATextButtonStop :text="list.interestYn === 'Y' ? '♥' : '♡'" class="red_button" @click="onClickInterestCorp(list)"/>
                    </div>
                  </dd>
                </dl>
              </div>
              <Paginate
                  v-if="recruitHallList.length > 0"
                  v-model="currentPage"
                  :page-count="totalPages"
                  :click-handler="onSelectPage"
              />
            </div>
            <div v-else class="lecture-none text-center">
              참가 기업이 없습니다.
            </div>
          </div>
          <!-- e: 참가기업 -->

          <!-- s: 채용공고 -->
          <div v-if="tabIndex === 2">
            <!-- s: 검색 -->
            <div class="filter-wrap" :class="{'open': searchOpen}">
              <p @click="searchOpen = !searchOpen">검색</p>
              <div class="filter">
                <dl>
                  <dt>기업명</dt>
                  <dd>
                    <KSAInput class="text-box" v-model="_searchInput.searchInput" placeholder="기업명을 입력해주세요." />
                  </dd>
                </dl>
                <div class="btn-wrap">
                  <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                  <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
              </div>
            </div>
            <!-- e: 검색 -->
            <div class="list-top" v-if="user.userGb === 'COMPANY'">
              <KSAPrimaryButton text="채용공고 등록" @click="onClickJobNoticeCreate" style="margin-left: auto" />
            </div>
            <div v-if="jobNoticeList.length > 0">
              <div class="corp-wrap">
                <dl v-for="list in jobNoticeList" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId, list.applicantCnt)">
                  <dt>
                    <KSAImage :src="list.ciImgDir"/>
                  </dt>
                  <dd>
                    <p class="text-over">{{ list.corpName }}</p>
                    <h1 class="text-over">{{ list.jobName }}</h1>
                    <p class="text-over">{{ list.interests }}</p>
                    <div v-if="user.userGb === 'STUDENT'">
                      <KSATextButtonStop :text="list.interestNoticeYn === 'Y' ? '♥' : '♡'" class="red_button" @click="onClickInterestNotice(list)"/>
                    </div>
                  </dd>
                </dl>
              </div>
              <Paginate
                  v-if="jobNoticeList.length > 0"
                  v-model="currentPage"
                  :page-count="totalPages"
                  :click-handler="onSelectPage"
              />
            </div>
            <div v-else class="lecture-none text-center">
              등록된 채용공고가 없습니다.
            </div>
          </div>
          <!-- e: 채용공고 -->

          <!-- s: 인재정보 -->
          <div v-if="tabIndex === 3">
            <!-- s: 검색 -->
            <div class="filter-wrap" :class="{'open': searchOpen}">
              <p @click="searchOpen = !searchOpen">검색</p>
              <div class="filter">
                <dl>
                  <dt>등록(공개)일</dt>
                  <dd>
                    <template v-for="group in searchMonths">
                      <KSARadioButton class="mr-md" name="searchMonthGb" :label="group.label" v-model="_searchInput.searchMonthType" :value="group.value" />
                    </template>
                  </dd>
                </dl>
                <dl>
                  <dt>거주 지역</dt>
                  <dd class="residence-selected">
                    <button @click="showSearchResidenceModal()"><i>+</i>지역 선택</button>
                    <span v-for="option in _searchInput.searchResidences" :key="option">
                        {{ option }}<i @click="deleteResidence(option)">삭제</i>
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dt>관심 카테고리</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="interestGbListRef"
                        className="mr-md"
                        name="searchInterests"
                        v-model="_searchInput.searchInterests"
                        :options="data_interests" />
                  </dd>
                </dl>
                <dl>
                  <dt>최종학력</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="schoolGbListRef"
                        className="mr-md"
                        name="searchSchoolGbs"
                        v-model="_searchInput.searchSchoolGbs"
                        :options="data_schoolGb" />
                  </dd>
                </dl>
                <dl>
                  <dt>최종학력 상태</dt>
                  <dd>
                    <KSACheckBoxGroup
                        ref="eduTenureGbListRef"
                        className="mr-md"
                        name="searchEduTenureGbs"
                        v-model="_searchInput.searchEduTenureGbs"
                        :options="data_eduTenureGb" />
                  </dd>
                </dl>
                <dl style="align-items: start;">
                  <dt>전공계열(주전공)</dt>
                  <dd class="majorGb" :class="spreadMajorGbClass">
                    <button @click="spreadMajorGb">34개 <i></i></button>
                    <KSACheckBoxGroup
                        ref="majorGbListRef"
                        className="mr-md"
                        name="searchMajorGbs"
                        v-model="_searchInput.searchMajorGbs"
                        :options="data_majorGb" />
                  </dd>
                </dl>
                <div class="btn-wrap">
                  <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                  <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
              </div>
            </div>
            <!-- e: 검색 -->
            <!-- s: 이력서 등록 -->
            <!-- 구직자일 때, 공개된 이력서가 없으면 이력서 등록하면서 공개 -->
            <div class="info-box" v-if="user.userGb === 'STUDENT' && (resumeList.length === 0 || allTitlesHaveAsterisk())">
              <p>'인재정보'에 공개된 이력서가 없습니다. 공개할 이력서를 등록 및 설정해 주세요.</p>
              <KSAPrimaryButton text="이력서 등록(공개설정)" @click="router.push({name: 'MyPageJobFairDetail', params:{id: jobDetail.ojfId}})" />
            </div>
            <!-- e: 이력서 등록 -->
            <div class="list-top">
              <!--p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p-->
              <div class="list-top mb-n-xs" style="margin-left: auto;">
                <KSAPrimaryButton v-show="user.userGb === 'COMPANY'" text="엑셀 다운로드" @click="onClickExcelDownload" class="mr-xs" />
                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
              </div>
            </div>
            <div class="table-form">
              <table class="table-form board-mobile-vertical">
                <tr>
                  <!--th>번호</th-->
                  <th>이름</th>
                  <th>이력서 제목</th>
                  <th>관심 카테고리</th>
                  <th>면접 가능일</th>
                  <th>등록(공개)일</th>
                  <th v-show="user.userGb === 'COMPANY' && userCorpMasterYn === 'Y'">면접제안</th>
                  <th v-show="user.userGb === 'COMPANY' && userCorpMasterYn === 'Y'">관심인재</th>
                </tr>
                <tr v-for="list in resumeList">
                  <!--td>{{ list.boardNo }}</td-->
                  <td>{{ list.userName }}</td>
                  <td class="text-overflow long-overflow">
                    <p v-if="hasAsterisk(list.title)">
                      {{ list.title }}
                    </p>
                    <div v-else>
                      <p class="file" v-if="list.fileYn === 'Y'" v-for="resumeAttaches in list.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                        {{ resumeAttaches.fileName }}
                      </p>
                      <p class="clickable blue" v-else @click="onClickInterestMyResume(list.resumeId, jobDetail.ojfId, list.interestYn)">
                        {{ list.title }}
                      </p>
                    </div>
                  </td>
                  <td>{{ list.interests }}</td>
                  <td class="word-break-all">
                    <span v-if="list.intvInYn === 'Y' && isAllSelected">
                      전체 일정 가능
                      [{{ list.intvAbleDay }}]
                    </span>
                    <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                    <span v-else>면접 일정 조율</span>
                  </td>
                  <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                  <td v-show="user.userGb === 'COMPANY' && userCorpMasterYn === 'Y'">
                    <KSATextButton text="면접제안" @click="onClickResumeCorpYn(list.resumeId)" />
                  </td>
                  <td v-show="user.userGb === 'COMPANY' && userCorpMasterYn === 'Y'">
                    <KSATextButton text="♥" v-if="list.interestYn === 'Y'" @click="onClickInterestYn(list.resumeId, list.interestYn)" class="red_button" />
                    <KSATextButton text="♡" v-else @click="onClickInterestYn(list.resumeId, list.interestYn)" class="red_button" />
                  </td>
                </tr>
              </table>
            </div>
            <div class="result-none lecture-none" v-if="resumeList.length === 0">
              등록된 인재정보가 없습니다.
            </div>
            <Paginate
                v-if="resumeList.length > 0"
                v-model="currentPage"
                :page-count="totalPages"
                :click-handler="onSelectPage"
            />
          </div>
          <!-- e: 인재정보 -->
        </div>
      </div>
    </div>
  </div>
  <JobFairCorpInfoModal ref="corpInfoModal"/> <!-- 기업정보 보기 -->
  <JobFairJobNoticeModal ref="jobNoticeModal"/> <!-- 채용공고 보기 -->
  <SearchResidenceModal ref="searchResidenceModal" @submitSelection="handleSelectionSubmit"/> <!-- 거주지역 -->
  <JobFairResumeModal ref="jobFairResumeModal"/> <!-- 특별채용관 이력서 상세 -->
  <JobFairJobNoticeListModal ref="jobNoticeListModal" /> <!-- 채용공고 선택 목록 -->
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.clickable {
  text-decoration: underline;
  cursor: pointer;
}
.file, .blue {
  color: $blue_color !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &.badge {
      position: relative;
      top: -4px;
    }
  }
}

.btn {
  min-height: 48px;
  height: fit-content;
  border:none;
  cursor:pointer;
  border-radius: 4px;
  padding: 10px 20px;
  background: $blue_color;
  @include font-size_sm;
  color: #fff;
  &.sm_btn {
    height: 30px;
    padding: 1px 10px;
  }
  &.black_button {
    background: $black_color;
    color: #fff;
  }
  &:disabled {
    cursor: default !important;
    background: $gray-light_color !important;
    color: $gray-regular_color !important;
  }
  small {
    display: block;
    line-height: normal;
  }
}

.corp-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 22px;
  dl {
    flex: 1 1 calc(25% - 22px);
    max-width: calc(25% - 16px);
    height: 200px;
    border: 1px solid $gray-regular_color;
    border-radius: 6px;
    padding: 16px;
    cursor: pointer;
    dt {
      width: 100%;
      height: 70px;
      border: 1px solid $gray-regular_color;
    }
    dd {
      position: relative;
      margin-top: 10px;
      .text-over {
        display: block;
      }
      h1 {
        font-size: 18px;
      }
      p {
        max-width: 100%;
        &.link {
          color: $blue_color;
        }
        &:last-of-type {
          font-size: 14px;
        }
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
      }
    }
  }
}

.info-box {
  display: flex;
  background: $gray-light_color;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-block: 16px;
  padding: 16px;
}
</style>
